import {NgModule} from '@angular/core';
import {SharedModule} from '../../shared/modules/shared.module';
import {LoginModule} from './login/login.module';
import {LogoutModule} from './logout/logout.module';
import {NotFoundModule} from './not-found/not-found.module';
import {PublicWrapperModule} from './public-wrapper/public-wrapper.module';
import {HomeModule} from "./home/home.module";
import {AboutModule} from "./about/about.module";
import {ProjectsModule} from "./projects/projects.module";
import {ContactModule} from "./contact/contact.module";
import {CityTouchModule} from "./city-touch/city-touch.module";

@NgModule({
    imports: [
        SharedModule
    ],
    exports: [
        PublicWrapperModule,
        HomeModule,
        AboutModule,
        ProjectsModule,
        ContactModule,
        CityTouchModule,
        LoginModule,
        LogoutModule,
        NotFoundModule
    ],
})
export class PublicModule {
}



// WEBPACK FOOTER //
// /var/www/luvi/frontend/src/app/components/public/public.module.ts